import { ApiUserData } from "./ApiUserData"
import { getMypageUser } from "../../api/v1/mypage/user/get"
import { MypageUserGetInputModel } from "../../api/v1/mypage/user/GetInputModel"

export const fetchMyUserInfo = (): Promise<ApiUserData> => {
  return getMypageUser(new MypageUserGetInputModel())
}
